import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class InterfaceDeclarationCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.InterfaceDeclaration;
    }
    visitNode(_sb, _node, _optionsIn) {
    }
}

//# sourceMappingURL=InterfaceDeclarationCompiler.js.map
